import React, { useState } from "react";
import { stratificationService } from "../../services/stratification.services";
import { SearchSelect } from "./SearchSelect";
import { TrashCan } from "../Icons/TrashCan";

export const RiskDiagnosesSection = ({ items, onRefresh }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSearch = async (query) => {
    const data = await stratificationService.searchDiagnoses(query);
    return data.results || [];
  };

  const handleAdd = async () => {
    if (!selectedDiagnosis) return;
    setSaving(true);
    try {
      await stratificationService.createRiskDiagnosis({
        diagnosis_id: selectedDiagnosis.id,
      });
      setSelectedDiagnosis(null);
      setShowAddForm(false);
      setIsExpanded(true);
      onRefresh();
    } catch (err) {
      console.error("Error creating risk diagnosis:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Opravdu chcete odstranit tuto diagnózu?")) return;
    try {
      await stratificationService.deleteRiskDiagnosis(id);
      setIsExpanded(true);
      onRefresh();
    } catch (err) {
      console.error("Error deleting risk diagnosis:", err);
    }
  };

  return (
    <div className="strat-section">
      <div
        className="strat-section-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className="strat-section-title">Rizikové diagnózy</h3>
        <span className="strat-section-toggle">{isExpanded ? "−" : "+"}</span>
      </div>

      {isExpanded && (
        <div className="strat-section-content">
          <div className="strat-table-header">
            <div className="strat-header-cell strat-cell--diag-code">Kód</div>
            <div className="strat-header-cell strat-cell--diag-name">
              Název diagnózy
            </div>
            <div className="strat-header-cell strat-cell--actions" />
          </div>

          {items.length === 0 && !showAddForm && (
            <div className="strat-empty">
              Žádné rizikové diagnózy nebyly přidány.
            </div>
          )}

          {items.map((item, idx) => (
            <div
              key={item.id}
              className={`strat-row ${idx % 2 === 1 ? "strat-row--odd" : ""}`}
            >
              <div className="strat-cell strat-cell--diag-code">
                {item.diagnosis?.code || ""}
              </div>
              <div className="strat-cell strat-cell--diag-name">
                {item.diagnosis?.name || ""}
              </div>
              <div className="strat-cell strat-cell--actions">
                <button
                  className="strat-action-btn strat-action-btn--delete"
                  onClick={() => handleDelete(item.id)}
                  title="Odstranit"
                >
                  <TrashCan className="strat-action-icon" />
                </button>
              </div>
            </div>
          ))}

          {showAddForm && (
            <div className="strat-inline-form">
              <div className="strat-inline-field strat-inline-field--grow">
                <span className="strat-inline-label">Diagnóza</span>
                <SearchSelect
                  placeholder="Vyhledat diagnózu (kód / název)..."
                  onSearch={handleSearch}
                  onSelect={setSelectedDiagnosis}
                  renderOption={(item) => (
                    <>
                      <span className="strat-search-option--code">
                        {item.code}
                      </span>
                      {item.name}
                    </>
                  )}
                />
                {selectedDiagnosis && (
                  <small>
                    Vybráno: {selectedDiagnosis.code} – {selectedDiagnosis.name}
                  </small>
                )}
              </div>
              <div style={{ display: "flex", gap: 8, alignSelf: "flex-end" }}>
                <button
                  className="strat-add-btn"
                  onClick={handleAdd}
                  disabled={!selectedDiagnosis || saving}
                >
                  {saving ? "Ukládání..." : "Uložit"}
                </button>
                <button
                  className="strat-add-btn strat-add-btn--secondary"
                  onClick={() => {
                    setShowAddForm(false);
                    setSelectedDiagnosis(null);
                  }}
                >
                  Zrušit
                </button>
              </div>
            </div>
          )}

          <div className="strat-add-row">
            <button
              className="strat-add-btn"
              onClick={() => setShowAddForm(true)}
              disabled={showAddForm}
            >
              + Přidat diagnózu
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
